import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// 1. 导入 store 的实例对象
import store from './store/store'
// import { Dialog} from 'element-ui';
import './assets/css/font.css'
import './assets/css/global.css'
import 'swiper/swiper.css'
import 'amfe-flexible'
import './utils/rem'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
store.dispatch('m_user/GetInfo')
// Vue.use(Dialog)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
